export * from './translator.module';